// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Hn16","notes":"Notes_notes__3SK3P"};